import { cn } from "@garther/ui/libs";
import React from "react";

export interface SelectOption {
  value: string;
  label: string; // i18n key
}

export interface SelectProps extends Omit<React.SelectHTMLAttributes<HTMLSelectElement>, "children"> {
  label?: string;
  required?: boolean;
  labelClassName?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, label, labelClassName, required, error, options, placeholder, ...props }, ref) => {
    return (
      <div>
        {label && (
          <div className={cn("text-text-secondary font-medium text-responsive-sm", labelClassName)}>
            {label} {required && <span className="text-red-500">(*)</span>}
          </div>
        )}
        <select
          className={cn(
            "h-10 w-full rounded-sm border border-border-light bg-transparent px-3 py-2 text-sm font-normal text-text-primary",
            "focus:outline-none focus:border-border-dark",
            "disabled:cursor-not-allowed disabled:opacity-50",
            error && "border-red-200",
            className
          )}
          ref={ref}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && <p className="text-responsive-sm text-red-400">{error}</p>}
      </div>
    );
  }
);
